+function ($) {
    'use strict';

    var popupWindow = function (element, option) {
        this.window = $(element);
        this.closeBtn = this.window.find('.popup-close');
        this.animate = false;
        var self = this;
        this.closeBtn.bind('click', function () {
            self.hide();
            self.window.trigger('windowHidden');
            return false;
        });

        $(document).bind('keydown', function (ev) {
            if(ev.keyCode === 27) {
                self.closeBtn.trigger('click');
                return false;
            }
        });

        if(option) {
            switch (option) {
                case 'show':
                    this.show();
                    break;

                case 'hide':
                    this.hide();
                    break;
            }
        }

    };

    popupWindow.prototype.show = function () {
        if (!this.animate) {
            this.animate = true;
            var self = this;
            this.window.css({
                'display': 'block'
            });
            this.window.animate({
                'opacity': 1,
            }, {
                'duration': 300,
                'specialEasing': {
                    'opacity': 'swing',
                },
                'complete': function () {
                  self.animate = false;
                }
            });
            $('body').css({
                'overflow': 'hidden'
            });
        }
    };

    popupWindow.prototype.hide = function () {
        if (!this.animate) {

            var self = this;
            this.animate = true;
            this.window.animate({
                'opacity':0,
            }, {
                'dusration': 300,
                'specialEasing': {
                    'opacity':'swing',
                },
                'complete': function (){
                    self.animate = false;
                    self.window.css('display', 'none');
                    $('body').css({
                        'overflow': 'auto'
                    });
                }
            });
        }
    };

    var constructor = function (options) {
        //вернуть надо объект jQuery
        return this.each(function () {
            return new popupWindow(this, options)
        });
    };



    var old = $.fn.popupWindow;

    $.fn.popupWindow = constructor;
    $.fn.popupWindow.constructor = constructor;

    $.fn.popupWindow.noConflict = function () {
        $.fn.popupWindow = old;
        return this;
    }
}(jQuery);